import { typeInsumoAdd } from "../../../../..";
import { typeListarInsumosPlanejados } from "../../../../../meta";


export function obterNomeInsumo(item_insumo: typeInsumoAdd) {
    switch (item_insumo?.cod_tipo_uso) {
        case 1:
            return item_insumo?.nome_produto;
        case 2:
            return item_insumo?.nome_variedade_hibrido;
        case 3:
            return item_insumo?.nome_fertilizante;
        case 4:
            return item_insumo?.nome_produto;
        case 5:
            return item_insumo?.nome_adjuvante;
        case 6:
            return item_insumo?.nome_calcario;
        case 8:
            return item_insumo?.nome_inoculante;
        case 9:
            return item_insumo?.nome_biologico;
        case 10:
            return item_insumo?.nome_aditivo;

        default:
            return '';
    }
}

export function obterCodInsumo(item_insumo: typeInsumoAdd) {
    const cod_tipo = item_insumo?.cod_tipo_uso ?? item_insumo?.cod_tipo;
    switch (cod_tipo) {
        case 1:
            return item_insumo?.cod_produto;
        case 2:
            return item_insumo?.cod_variedade_hibrido;
        case 3:
            return item_insumo?.cod_fertilizante;
        case 4:
            return item_insumo?.cod_produto;
        case 5:
            return item_insumo?.cod_produto;
        case 6:
            return item_insumo?.cod_produto;
        case 8:
            return item_insumo?.cod_produto;
        case 9:
            return item_insumo?.cod_produto;
        case 10:
            return item_insumo?.cod_produto;
        default:
            return null;
    }
}

export function obterPorcentagemPrecisao(insumos_planejados: typeListarInsumosPlanejados[], cod_insumo: number,
    quantidade_executada: number, nome_medida: string, minMax: { min: number, max: number }, porcentagem_area_executada: number): {
        precisao: string,
        porcentagem_erro: string,
        diferenca: string,
        quantidade_planejada: string,
        status: string,
        precisao_number: number,
        error_percentage: number,
        quantidade_min: string,
        quantidade_max: string,
        quantidade_planejada_proporcional: string
    } {

    const add_cod_insumo = insumos_planejados.map(i => { return { ...i, cod_insumo: obterCodInsumo(i as unknown as typeInsumoAdd) } });

    const quantidade_planejada = add_cod_insumo.find(i => i.cod_insumo === cod_insumo)?.quantidade;
    const quantidade_planejada_proporcional = quantidade_planejada * (porcentagem_area_executada / 100);

    if (!quantidade_planejada) return { precisao: '0%', porcentagem_erro: '0%', diferenca: '0', quantidade_planejada: '0', status: 'Indefinido', precisao_number: 0, quantidade_min: '0', quantidade_max: '0', error_percentage: 0, quantidade_planejada_proporcional: '0' };

    const diferenca = Math.abs(Number(quantidade_planejada_proporcional) - Number(quantidade_executada));
    const porcentagem_erro = (diferenca / Number(quantidade_planejada_proporcional)) * 100;
    const precisao = 100 - porcentagem_erro;
    const status = Number(quantidade_executada) > Number(quantidade_planejada_proporcional) ? '-' : (Number(quantidade_executada) < Number(quantidade_planejada_proporcional) ? '+' : '=');

    const qtd_plan = Number(quantidade_planejada_proporcional);
    const qtd_min = qtd_plan - (qtd_plan * ((minMax.min) / 100));
    const qtd_max = qtd_plan + (qtd_plan * ((minMax.max) / 100));

    return {
        precisao: `${precisao < 0 ? 0 : precisao.toFixed(2)}%`,
        porcentagem_erro: `${porcentagem_erro.toFixed(2)}%`,
        diferenca: `${Number(diferenca)?.toFixed(2)} ${nome_medida}`,
        quantidade_planejada: `${Number(quantidade_planejada)?.toFixed(2)} ${nome_medida}`,
        quantidade_planejada_proporcional: `${Number(quantidade_planejada_proporcional)?.toFixed(2)} ${nome_medida}`,
        status: status,
        precisao_number: Math.round(precisao),
        error_percentage: Number(porcentagem_erro.toFixed(2)),
        quantidade_min: minMax.min ? `${Number(qtd_min).toFixed(2)} ${nome_medida} (-${minMax.min}%)` : 'não informado',
        quantidade_max: minMax.max ? `${Number(qtd_max).toFixed(2)} ${nome_medida} (+${minMax.max}%)` : 'não informado'
    };
};

export function obterMinMax(insumos_planejados: typeListarInsumosPlanejados[], cod_insumo: number) {
    const add_cod_insumo = insumos_planejados.map(i => {
        return {
            ...i,
            cod_insumo: obterCodInsumo(i as unknown as typeInsumoAdd)
        }
    });

    const insumo = add_cod_insumo.find(i => i.cod_insumo === cod_insumo);

    if (!insumo) return { min: 0, max: 0 };

    return { min: insumo.maximo_abaixo, max: insumo.maximo_acima };
}

export function colorPrecision(error_percentage: number, status: string, { min, max }: { min: number, max: number }) {

    let allowed_limit = 0;

    if (status === '=') allowed_limit = 0;
    else if (status === '-') allowed_limit = max; // Overdose (Exec > Plan)
    else if (status === '+') allowed_limit = min; // Underdose (Exec < Plan)

    if (min === 0 || max === 0 || min === null || max === null || min === undefined || max === undefined) return { bg: 'var(--border-color)', color: '#32393b' };

    // Green zone: Error is within allowed limit
    if (error_percentage <= allowed_limit) {
        if (error_percentage === 0) return { bg: '#e9f4ec', color: '#04c284' }; // Perfect Green
        return { bg: '#e9f5fe', color: '#2275db' }; // "Good" Blue (Authorized deviation)
    }

    // Violation
    return { bg: '#ffecee', color: '#dc272f' }; // Red
}


// export const dummy_tipos_uso = [
//     {cod: 1, nome: 'GERAL'},
//     {cod: 2, nome: 'SEMENTE (VARIEDADE/HÍBRIDO)'},
//     {cod: 3, nome: 'FERTILIZANTE'},
//     {cod: 4, nome: 'TRATAMENTO SEMENTE'},
//     {cod: 5, nome: 'ADJUVANTE'},
//     {cod: 6, nome: 'CALCÁRIO'},
//     // {cod: 7, nome: 'GESSO'},
//     {cod: 8, nome: 'INOCULANTE'},
//     {cod: 9, nome: 'BIOLÓGICO'},
// ];